import { createSlice } from '@reduxjs/toolkit'
import { GridLogicOperator } from '@mui/x-data-grid-pro'
import { get } from 'lodash'
import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM } from 'components/common/map/constants'

export const FILTER_PANEL_COLLAPSE_WIDTH = 620
export const FILTER_PANEL_DEFAULT_OPEN_WIDTH = 900

export const CREATE_DRAFT_CS_TABS = {
  CREATE: 'CREATE_TAB',
  SCHEDULE: 'SCHEDULE_TAB',
}

export const CSD_MARKER_TYPE = {
  WEEK_DAY: 'weekDay',
  ROUTE: 'route',
}

export const INITIAL_CAMERA = {
  center: DEFAULT_MAP_CENTER,
  zoom: DEFAULT_MAP_ZOOM,
}

const initialState = {
  isOpen: false,
  accountId: null,
  locationId: null,
  currentTab: CREATE_DRAFT_CS_TABS.CREATE,
  rowSelectionModel: [],
  drawerWidth: 900,
  isFilterPanelOpen: true,
  filterPanelSizes: {
    filterPanel: 35,
    servicesPanel: 65,
  },
  map: {
    markerType: CSD_MARKER_TYPE.WEEK_DAY,
    isMapReady: true,
    camera: INITIAL_CAMERA,
  },
  filterModel: {
    items: [],
    quickFilterExcludeHiddenColumns: false,
    quickFilterValues: [],
    quickFilterLogicOperator: GridLogicOperator.And,
  },
}

const createDraftCSDSlice = createSlice({
  name: 'createDraftCSD',
  initialState,
  reducers: {
    resetCSD: state => ({
      ...initialState,
      isOpen: state.isOpen,
      drawerWidth: state.drawerWidth,
      isFilterPanelOpen: state.isFilterPanelOpen,
      filterPanelSizes: state.filterPanelSizes,
    }),
    openCSD: (state, { payload }) => {
      state.isOpen = true
      state.isFilterPanelOpen = true
      if (payload?.drawerWidth) {
        state.drawerWidth = payload.drawerWidth
      }
    },
    closeCSD: (state, action) => {
      state.isOpen = false
    },
    setRowSelectionModel(state, { payload }) {
      state.rowSelectionModel = payload || []
    },

    setFilterModel(state, { payload }) {
      state.filterModel = {
        ...state.filterModel,
        ...payload,
      }
    },
    changeToScheduleTab: state => {
      state.currentTab = CREATE_DRAFT_CS_TABS.SCHEDULE
    },
    changeToCreateTab: state => {
      state.currentTab = CREATE_DRAFT_CS_TABS.CREATE
    },
    setAccountId: (state, { payload }) => {
      state.accountId = payload
    },
    setLocationId: (state, { payload }) => {
      state.locationId = payload
    },
    setDrawerWidth: (state, { payload }) => {
      state.drawerWidth = payload
    },
    setIsFilterPanelOpen: (state, { payload }) => {
      state.isFilterPanelOpen = payload
    },
    setFilterPanelSizes: (state, { payload }) => {
      state.filterPanelSizes = payload
    },
    setMapMarkerType: (state, { payload }) => {
      state.map.markerType = payload
    },
    setIsMapReady: (state, { payload }) => {
      state.map.isMapReady = payload
    },
    setMapCamera: (state, { payload }) => {
      state.map.camera = payload
    },
  },
})

export const {
  setAccountId,
  setLocationId,

  changeToCreateTab,
  changeToScheduleTab,
  resetCSD,
  setRowSelectionModel,
  setFilterModel,
  setDrawerWidth,
  setIsFilterPanelOpen,
  setFilterPanelSizes,
  setMapMarkerType,
  setIsMapReady,
  setMapCamera,
  openCSD,
  closeCSD,
} = createDraftCSDSlice.actions

export const selectIsCSDOpen = state => get(state, 'createDraftCSD.isOpen', false)
export const selectCSDAccountId = state => get(state, 'createDraftCSD.accountId')
export const selectCSDRowSelectionModel = state => get(state, 'createDraftCSD.rowSelectionModel')
export const selectCSDFilterModel = state => get(state, 'createDraftCSD.filterModel')
export const selectCSDCurrentTab = state => get(state, 'createDraftCSD.currentTab', CREATE_DRAFT_CS_TABS.CREATE)
export const selectCSDLocationId = state => get(state, 'createDraftCSD.locationId')

export const selectCSDDrawerWidth = state => get(state, 'createDraftCSD.drawerWidth', initialState.drawerWidth)
export const selectCSDIsFilterPanelOpen = state => get(state, 'createDraftCSD.isFilterPanelOpen', true)
export const selectCSDFilterPanelSizes = state => get(state, 'createDraftCSD.filterPanelSizes', initialState.filterPanelSizes)

export const selectCSDMapMarkerType = state => get(state, 'createDraftCSD.map.markerType', CSD_MARKER_TYPE.WEEK_DAY)
export const selectCSDIsMapReady = state => get(state, 'createDraftCSD.map.isMapReady', true)
export const selectCSDMapCamera = state => get(state, 'createDraftCSD.map.camera', INITIAL_CAMERA)

export default createDraftCSDSlice.reducer
